<template>
    <div class="index_wrap">
        <button class="btn menubt"><i class="fas fa-chevron-right"></i>i<br/>n<br/>d<br/>e<br/>x</button>
        <h3>INDEX</h3>
        <ul>
            <li v-for="(slide,index) in slides" :key="slide.title">
                <a v-if="checkAvailableNavigation(index + 1)"
                    href="#"
                    @click.prevent="$emit('goPage',(index + 1))"
                    :class="index + 1 == contents.slideNumber ? 'active' : ''"
                >ㆍ{{slide.title}}</a>
                <a v-else
                    disabled
                    :style="{color:'black'}"
                >ㆍ{{slide.title}}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import {pad} from '../helpers'
export default {
    props : ['contents','slides'],
    data(){
        return{
        }
    },
    computed:{
        visitCookieName(){
            return 'aw/' + this.contents.lectureCode + '/' + this.contents.chapterId;
        }
    },
    methods:{
        getFileName(str){
            return pad(str) + ".html"
        },
        goPage(page){
            if(typeof settings.goPage !== 'undefined' && settings.goPage != null){
                return  settings.goPage(page);
            }
            location.href =  "./" + pad(page) + ".html";
        },
        checkAvailableNavigation(index){
            if(this.contents.navigate == 'N'){
                if(parseInt(index) > parseInt($cookies.get(this.visitCookieName))){
                    return false;
                }
            }
            return true;
        }
    },
    mounted(){
        $(".menubt").click(function(){
            $(".index_wrap").toggleClass("active");
            $('body').toggleClass('active');
            $(".closebt").click(function(){
                $(".index_wrap").removeClass("active");
                $('body').removeClass('active');
            });
        });
    }
}
</script>